import { render, staticRenderFns } from "./IntroductionLayout.vue?vue&type=template&id=60c4f192&scoped=true&"
import script from "./IntroductionLayout.vue?vue&type=script&lang=js&"
export * from "./IntroductionLayout.vue?vue&type=script&lang=js&"
import style0 from "./IntroductionLayout.vue?vue&type=style&index=0&id=60c4f192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60c4f192",
  null
  
)

export default component.exports